export const mmToPt = (mm: number) => mm * 2.83465

export const pt15 = mmToPt(15)
export const pt25 = mmToPt(30)
export const pt50 = mmToPt(50)
export const pt75 = mmToPt(75)
export const pt80 = mmToPt(80)